import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'

const getTagById = async (id) => {
  const response = await API.graphql({
    query: getTagByIdQuery,
    variables: {
      id
    },
    authMode: 'API_KEY'
  })
  return response.data
}

const getTagByIdQuery = gql`
  query GetTagById($id: ID!) {
    getTagById(id: $id) {
      id
      name
      count
      description
      type
    }
  }
`
export { getTagById, getTagByIdQuery }
